import { addNestingAndSubfolders, splitFoldersList } from 'newJs/utils/folderList';
import { useMemo, useState } from 'react';
import { useQuery } from 'react-query';

import { REACT_QUERY_NAMES as RQN } from 'newJs/config';
import { /* useFoldersCaching, */ useFoldersStore } from 'newJs/state';

const dataFetcher = (fetch, v2) => {
    // console.log('init fetch');
    return {
        // Fetch only the list of folders
        listOnly: async () => await fetch(
            { url: v2.getFoldersListNoCache() }
        ),
        // Fetch full folders data
        fullData: async (disableCache) => await fetch(
            { url: v2.getFoldersList(disableCache) }
        )
    };
};

const useFoldersList = (MAPI/* , params */) => {
    // console.log(params);
    const { fetch, v2 } = MAPI;
    const composePages = ['forward', 'reply'];
    const disableListLoad = composePages.some(page => window.location.pathname.includes(page));
    const invalidateCache = !disableListLoad; // Must be true always to get the latest data
    // const invalidateCache = useFoldersCaching((state) => state.invalidateCache);
    const foldersList = useFoldersStore((state) => state.foldersList);
    const setFoldersList = useFoldersStore((state) => state.updateFoldersList);
    const [listLoaded, setListLoaded] = useState(Object.keys(foldersList).length > 0);
    const fetchData = useMemo(() => dataFetcher(fetch, v2), [fetch, v2]);

    const { status: listOnlyStatus } = useQuery(
        [RQN.get('FOLDERS_LIST-ONLY')],
        () => fetchData.listOnly(),
        {
            // retry: 1,
            enabled: !listLoaded,
            initialData: () => {
                // console.log(Object.keys(foldersList).length);
                if (Object.keys(foldersList).length > 0) {
                    return foldersList;
                }
            },
            onSuccess: (data) => {
                // console.log('list success:', data);
                const withNesting = addNestingAndSubfolders(data);
                setFoldersList(splitFoldersList(withNesting, listLoaded));
                setListLoaded(true);
            }
        }
    );

    const { status: listFullStatus, isFetching, isLoading } = useQuery(
        [RQN.get('FOLDERS_LIST-FULL'), { invalidateCache }],
        () => fetchData.fullData(invalidateCache),
        {
            enabled: listLoaded,
            onSuccess: (data) => {
                // console.log('list success', data);
                const withNesting = addNestingAndSubfolders(data);
                setFoldersList(splitFoldersList(withNesting, listLoaded));
                setListLoaded(true);
            }
        }
    );

    return {
        isFetching,
        isLoading,
        data: foldersList,
        statuses: { listFullStatus, listOnlyStatus },
    };
};

export default useFoldersList;
